import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../../../shared/services/account.service';
import { WebcallSummary } from '../../../../account/account.model';
import * as moment from 'moment';
import { Observable } from 'rxjs';

@Component({
  selector: 'cc-webcall-balance',
  templateUrl: './webcall-balance.component.html',
  styleUrls: ['./webcall-balance.component.scss']
})
export class WebcallBalanceComponent implements OnInit {
  public webcallSummary$: Observable<WebcallSummary>;

  constructor(private accountService: AccountService) {}

  ngOnInit() {
    const since = moment().startOf('day');
    this.webcallSummary$ = this.accountService.getWebcallSummary(since);
    console.log(this.webcallSummary$);
  }

  usedPercentage(webcallSummary: WebcallSummary) {
    return webcallSummary.webcallLimit ? Math.round(webcallSummary.webcallUsed * 100 / webcallSummary.webcallLimit) : 0;
  }

  usedPercentagePointer(webcallSummary: WebcallSummary) {
    if (!webcallSummary.webcallLimit) {
      return '100';
    } else {
      return this.usedPercentage(webcallSummary) ? (this.usedPercentage(webcallSummary) - 1) % 100 + 1 : 0;
    }
  }
}
